// extracted by mini-css-extract-plugin
module.exports = {"jumbo":"styles_jumbo__3gnTd","container":"styles_container__37Vce","paragraph":"styles_paragraph__25tYS"};